import React from "react";
import { Shield, Network, Globe } from "lucide-react";
import SectionHeading from "./SectionHeading";

const features = [
  {
    icon: Shield,
    title: "Seasoned Experts",
    description:
      "Our AI researchers and engineers carry decades of combined experience across Fortune 500 deployments and cutting-edge research.",
  },
  {
    icon: Network,
    title: "Diverse Capabilities",
    description:
      "From computer vision and NLP to generative AI — we cover the full spectrum of intelligent system development end to end.",
  },
  {
    icon: Globe,
    title: "Collaborative Approach",
    description:
      "We embed with your team, align on measurable goals, and deliver iteratively — every model ships to solve a real business problem.",
  },
];

export default function WhyChooseUsAi() {
  return (
    <section className="bg-[#F8F8FB]">

      {/* Why Choose Us */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl mx-auto">
            <SectionHeading
              eyebrow="Why Choose Us"
              title="About Our AI Development Expertise"
              description="We combine deep technical depth with business sense — so every system we build earns its keep."
              theme="light"
              titleClassName="text-[#111827]"
              descriptionClassName="text-lg leading-8"
            />
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="group bg-white rounded-2xl border border-gray-200 p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#355dff]"
                >
                  <div className="w-14 h-14 rounded-xl bg-[#EBF2FF] flex items-center justify-center transition duration-300 group-hover:bg-[#355dff] mb-6">
                    <Icon
                      size={26}
                      className="text-[#355dff] transition duration-300 group-hover:text-white"
                    />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-500 leading-7 text-[15px]">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}